<template>
  <div v-if="this.$store.state.user && this.$store.state.user.is_admin">
    <p v-if="message">{{message}}</p>
    <div v-for="user of users" class="user">
      <div class="row">
        <div class="one column">{{user.pk_user_id}}</div>
        <div class="three columns">{{user.username}}</div>
        <div class="eight columns">{{user.email}}</div>
      </div>
      <div class="row">
        <div class="four columns">{{user.posts_made}} Posts</div>
        <div class="four columns">{{user.votes_cast}} Votes</div>
        <div class="four columns">{{user.times_won}} Wins</div>
      </div>
      <div class="row">
        <div class="four columns">
          <button
            class="button"
            @click="resetPassword(user.email)"
          >Reset PW</button>
        </div>
        <div class="four columns">
          <button
            class="button"
            @click="deleteUser(user.pk_user_id)"
          >Delete</button>
        </div>
        <div class="four columns">
          <button
            class="button"
            @click="nukeUser(user.pk_user_id)"
          >Nuke</button>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    Nope
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      users: []
    }
  },
  methods: {
    deleteUser (userId) {
      alert('todo')
    },
    resetPassword (userEmail) {
      this.$http.post(process.env.API_URL + '/forgotpassword.php', {
        email: userEmail
      }).then(res => {
        console.log(res)
      })
    }
  },
  created () {
    this.$http.get(process.env.API_URL + '/admin/getusers.php').then(res => {
      if (res.body.status === 'success') {
        this.users = res.body.data
      } else {
        this.message = res.body.data
      }
    })
  }
}
</script>

<style scoped>
.user:nth-child(odd) {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// Reset.vue?b7750cea